import axios from "axios";
import Qs from "qs";

// axios baseURL
// console.log(process.env.VUE_APP_BASE_API, "process.env.VUE_APP_BASE_API");
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "", // 实例 baseURL
  timeout: 6000
});

http.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

http.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    return Promise.reject(err);
  }
);

const fetchData = async (url, method, data = null) => {
  let httpOpts = { url, method };
  httpOpts =
    method === "get"
      ? {
          ...httpOpts,
          params: data,
          paramsSerializer: params => Qs.stringify(params, { indices: false }) // 序列化 处理数组
        }
      : { ...httpOpts, data };

  try {
    const res = await http(httpOpts);
    // console.log(res);
    return res.data;
  } catch (error) {
    return null;
  }
};

export const getRequest = (url, data) => fetchData(url, "get", data); // get请求
export const postRequest = (url, data) => fetchData(url, "post", data); // post请求
